import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getAuth, signOut } from 'firebase/auth';
import { getDatabase, ref, onValue, update } from 'firebase/database';
import '../style/account.css';

function formatDate(iso) {
  if (!iso) return '—';
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return iso;
  return date.toLocaleDateString('fr-FR', { day: 'numeric', month: 'long', year: 'numeric' });
}

const MonCompte = () => {
  const [userInfo, setUserInfo] = useState(null);
  const [editing, setEditing] = useState(false);
  const [newName, setNewName] = useState('');
  const navigate = useNavigate();

  const handleSignOut = () => {
    const auth = getAuth();
    signOut(auth)
      .then(() => navigate('/login'))
      .catch((error) => console.error('Erreur lors de la déconnexion :', error));
  };

  const handleUpdate = () => {
    const auth = getAuth();
    const userId = auth.currentUser?.uid;
    if (!userId) return;

    const db = getDatabase();
    const userRef = ref(db, `users/${userId}`);
    update(userRef, { name: newName.trim() })
      .then(() => setEditing(false))
      .catch((error) => console.error('Erreur lors de la mise à jour :', error));
  };

  useEffect(() => {
    const auth = getAuth();
    const userId = auth.currentUser?.uid;
    if (!userId) return undefined;

    const db = getDatabase();
    const userRef = ref(db, `users/${userId}`);
    const unsubscribe = onValue(userRef, (snapshot) => {
      const data = snapshot.val();
      setUserInfo(data);
      setNewName(data?.name || '');
    });

    return () => unsubscribe();
  }, []);

  return (
    <div className="bb-auth">
      <div className="bb-auth__card">
        <h1 className="bb-auth__title bb-display">Mon compte</h1>

        {editing ? (
          <div className="bb-field">
            <label className="bb-field__label" htmlFor="name">Nom</label>
            <input
              id="name"
              className="bb-input"
              type="text"
              value={newName}
              onChange={(e) => setNewName(e.target.value)}
            />
          </div>
        ) : (
          <div className="bb-account-info">
            <div className="bb-account-info__row">
              <span className="bb-account-info__label">Nom</span>
              <span className="bb-account-info__value">{userInfo?.name || '—'}</span>
            </div>
            <div className="bb-account-info__row">
              <span className="bb-account-info__label">Email</span>
              <span className="bb-account-info__value">{userInfo?.email || '—'}</span>
            </div>
            <div className="bb-account-info__row">
              <span className="bb-account-info__label">Membre depuis</span>
              <span className="bb-account-info__value">{formatDate(userInfo?.dateJoined)}</span>
            </div>
          </div>
        )}

        <div className="bb-auth__actions">
          {editing ? (
            <>
              <button type="button" className="bb-btn bb-btn--primary" onClick={handleUpdate}>
                Enregistrer
              </button>
              <button type="button" className="bb-btn" onClick={() => setEditing(false)}>
                Annuler
              </button>
            </>
          ) : (
            <button type="button" className="bb-btn" onClick={() => setEditing(true)}>
              Modifier mon nom
            </button>
          )}
        </div>

        <button type="button" className="bb-btn bb-btn--danger" onClick={handleSignOut}>
          Se déconnecter
        </button>
      </div>
    </div>
  );
};

export default MonCompte;
